import Vue from 'vue';

// Create a new Vue instance to use as an event bus
export const bus = new Vue();